import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminObatExport = () => {
    const [busy, setBusy] = useState(null);

    const download = async (kind, filename) => {
        setBusy(kind);
        try {
            const r = await axios.get(`${API}/admin/export/obat/${kind}`, { responseType: "blob" });
            const url = URL.createObjectURL(new Blob([r.data], { type: "text/csv" }));
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
            toast.success(`${filename} téléchargé ✓`);
        } catch {
            toast.error("Erreur d'export");
        } finally {
            setBusy(null);
        }
    };

    return (
        <div className="space-y-6">
            <div className="lux-card p-6">
                <div className="tracking-luxe text-[#B89C6A] mb-3">Export vers Obat</div>
                <p className="text-[13px] text-[#1C1E1D]/70 leading-relaxed max-w-2xl">
                    Obat ne proposant pas d'API publique, exportez ici vos données au format CSV (séparateur « ; », compatible Excel)
                    puis importez-les dans Obat — directement ou via votre conseiller Obat (
                    <a href="https://www.obat.fr/www/migrer-vers-obat/" target="_blank" rel="noreferrer" className="underline text-[#B89C6A]">
                        procédure de migration Obat
                    </a>
                    ).
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                    <div className="border hairline p-5">
                        <div className="font-serif-lux text-xl mb-1">Fiches clients</div>
                        <p className="text-[12px] text-[#1C1E1D]/60 mb-4">
                            Tous vos contacts dédupliqués : comptes clients, demandes de devis, rendez-vous et messages (nom, email, téléphone, adresse, source).
                        </p>
                        <button
                            data-testid="obat-export-clients"
                            onClick={() => download("clients", "obat-clients.csv")}
                            disabled={busy === "clients"}
                            className="btn-champagne disabled:opacity-50"
                        >
                            {busy === "clients" ? "Export…" : "Télécharger clients CSV ↓"}
                        </button>
                    </div>
                    <div className="border hairline p-5">
                        <div className="font-serif-lux text-xl mb-1">Devis détaillés</div>
                        <p className="text-[12px] text-[#1C1E1D]/60 mb-4">
                            Tous vos devis signables ligne par ligne : désignations, quantités, prix HT, TVA, totaux, statut (signé / en attente / refusé).
                        </p>
                        <button
                            data-testid="obat-export-devis"
                            onClick={() => download("devis", "obat-devis.csv")}
                            disabled={busy === "devis"}
                            className="btn-champagne disabled:opacity-50"
                        >
                            {busy === "devis" ? "Export…" : "Télécharger devis CSV ↓"}
                        </button>
                    </div>
                </div>
                <p className="mt-5 text-[11px] italic text-[#1C1E1D]/40">
                    💡 Si Obat vous fournit un jour un accès API partenaire (documentation + clé), la connexion automatique directe pourra être mise en place.
                </p>
            </div>
        </div>
    );
};
